module.exports = __webpack_public_path__ + "img/hair_front_female_pulled_back_mask.f817c4db.png";